<div class="city-links-container">
  <a href="/" class="back-link">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M19 12H5"/>
      <path d="M12 19l-7-7 7-7"/>
    </svg>
  </a>
  <h1 class="city-links-title">{{ cityName() }}</h1>
  <h2 class="city-links-title" style="text-align: center;font-size: 15px;"> Explore {{ cityName() }} taxi</h2>
  <div class="city-links-grid">
    @if (loading()) {
      <div class="loading-spinner">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    } @else if (error()) {
      <div class="error-message">
        {{ error() }}
      </div>
    } @else {
      @for (link of cityLinks(); track link.url) {
        <a [href]="'https://wetaxi.ma/' + link.url" target="_blank" class="city-link">{{ link.title }}</a>
      }
    }
  </div>
</div>
